import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { listFleetAsync } from "../../../../redux/features/fleetMaster";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";
import toast from "react-hot-toast";
import { changeStatus } from "../../../../Api/dispatch/fleet-dispatch";
import { Box, Button, Stack } from "@mui/material";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import {
   fleetMaintainanceReportAsync,
   fleetReportAsync,
} from "../../../../redux/features/reportSlice";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import { useBoolean } from "../../../../Hooks/useBoolean";

export default function FleetMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const fleetMaster = useSelector((state) => state.fleetMaster);
   const fleetMasterList = fleetMaster?.dataList;
   const [records, setRecords] = useState([]);

   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const fleetReportPopup = useBoolean();
   const maintainanceReportPopup = useBoolean();

   useEffect(() => {
      if (fleetMasterList) {
         setRecords(fleetMasterList);
      }
   }, [fleetMasterList]);

   // Handle active inactive
   const handleActiveInactive = (fleet) => {
      setIsActiveLoading({ id: fleet?.id, status: true });
      changeStatus({ id: fleet?.id, status: fleet?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: fleet?.id, status: false });
            dispatch(listFleetAsync({}));
            toast.success(
               `fleet ${fleet?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: fleet?.id, status: false });
            toast.error(
               `Failed to ${fleet?.is_active === "1" ? "deactivate" : "activate"} fleet`
            );
         });
   };
   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         fleetReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Vehicle No.",
                  "Vehicle Chasis No.",
                  "Vehicle Engine No.",
                  "Make",
                  "Model",
                  "Fuel Type",
                  "Vehicle Category",
                  "Vehicle Tonnage",
                  "Vehicle Dimension LxBxH (Feet)",
                  "Vehicle Owner Name",
                  "Financed by",
                  "EMI Amount",
                  "EMI Start Date",
                  "EMI End Date",
                  "Fitness Expiry Date",
                  "Fitness Amount",
                  "Insurance Company Name",
                  "Insurance Expiry Date",
                  "Insurance Amount",
                  "Local Permit Expiry Date",
                  "Local Permit Amount",
                  "National Permit Expiry Date",
                  "National Permit Amount",
                  "PUC Expiry Date",
                  "PUC Amount",
                  "MV Tax Expiry Date",
                  "MV Tax Amount",
                  "GPS Provider Name",
                  "GPS Amount",
                  "Fastag Bank Name",
                  "Vehicle Body Maker",
                  "Vehicle Body Maker Location",
               ];

               const subHeaders = [
                  "",
                  "",
                  "",
                  "",
                  "Tata / Eicher / Ashok leyland",
                  "Month Year",
                  "Diesel / CNG",
                  "20ft / 22ft / 24ft / 32ft SXL / 32ft MXL / Any Other mention",
                  " 5T, 6T, 7T, 8T, 9T, 10.5T, 15T, 18T",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Fabricator Name",
                  "",
               ];

               const fleetMasterDataArr = [];

               report?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     index + 1, // S. No.
                     item?.vehicle_no ?? "-", // Vehicle No.
                     item?.chasis_no ?? "-", // Vehicle Chasis No.
                     item?.engine_no ?? "-", // Vehicle Engine No.
                     item?.make?.make ?? "-", // Make
                     item?.model ?? "-", // Model
                     item?.fuel_type ?? "-", // Fuel Type
                     item?.vehicle_category?.category_name ?? "-", // Vehicle Category
                     item?.tonnage?.tonnage ?? "-", // Vehicle Tonnage
                     item?.dimension?.dimension ?? "-", // Vehicle Dimension LxBxH (Feet)
                     item?.vehicle_owner_name ?? "-", // Vehicle Owner Name
                     item?.financed_by ?? "-", // Financed by
                     item?.emi_amount ?? "-", // EMI Amount
                     item?.emi_start_date ?? "-", // EMI Start Date
                     item?.emi_end_date ?? "-", // EMI End Date
                     item?.fitness_expiry_date ?? "-", // Fitness Expiry Date
                     item?.fitness_amount ?? "-", // Fitness Amount
                     item?.insurance_company_name ?? "-", // Insurance Company Name
                     item?.insurance_expiry_date ?? "-", // Insurance Expiry Date
                     item?.insurance_amount ?? "-", // Insurance Amount
                     item?.local_permit_expiry_date ?? "-", // Local Permit Expiry Date
                     item?.local_permit_amount ?? "-", // Local Permit Amount
                     item?.national_permit_expiry_date ?? "-", // National Permit Expiry Date
                     item?.national_permit_amount ?? "-", // National Permit Amount
                     item?.puc_expiry_date ?? "-", // PUC Expiry Date
                     item?.puc_amount ?? "-", // PUC Amount
                     item?.mv_tax_expiry_date ?? "-", // MV Tax Expiry Date
                     item?.mv_tax_amount ?? "-", // MV Tax Amount
                     item?.gps_provider_name ?? "-", // GPS Provider Name
                     item?.gps_amount ?? "-", // GPS Amount
                     item?.fastag_bank_name ?? "-", // Fastag Bank Name
                     item?.fabricator_name ?? "-", // Vehicle Body Maker
                     item?.fabricator_location ?? "-" // Vehicle Body Maker Location
                  );

                  fleetMasterDataArr.push(arr);
               });

               console.log({ fleetMasterDataArr });

               // Combine headers and rows
               const sheetData = [headers, subHeaders, ...fleetMasterDataArr];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "FLEET_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               fleetReportPopup.onFalse();
            },
         })
      );
   };

   //  Download Maintainance Report
   const handleDownloadMaintainanceReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         fleetMaintainanceReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Vehicle No.",
                  "Vehicle Category",
                  "Vehicle Service Station Name",
                  "Vehicle Service Odometer Reading",
                  "Vehicle Service Date",
                  "Vehicle Service Amount",
                  "Tyre Station Name",
                  "Tyre Type",
                  "Tyre Change Date",
                  "Tyre Amount",
                  "Tyre Change Odometer Reading",
                  "Budgeted Maintenance Amount",
                  "Maintenance Type",
                  "Maintenance Date",
                  "Maintenance Amount",
               ];

               const fleetMasterDataArr = [];

               report?.forEach?.((item, index) => {
                  const arr = [];
                  arr.push(
                     "", // S. No.
                     "", // Vehicle No.
                     "", // Vehicle Category
                     "", // Vehicle Service Station Name
                     "", // Vehicle Service Odometer Reading
                     "", // Vehicle Service Date
                     "", // Vehicle Service Amount
                     "", // Tyre Station Name
                     "", // Tyre Type
                     "", // Tyre Change Date
                     "", // Tyre Amount
                     "", // Tyre Change Odometer Reading
                     "", // Budgeted Maintenance Amount
                     "", // Maintenance Type
                     "", // Maintenance Date
                     "" // Maintenance Amount
                  );

                  fleetMasterDataArr.push(arr);
               });

               console.log({ fleetMasterDataArr });

               // Combine headers and rows
               const sheetData = [headers, ...fleetMasterDataArr];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "MAINTAINANCE.xlsx");
               dispatch(backdropLoadingAction(false));
               maintainanceReportPopup.onFalse();
            },
         })
      );
   };

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listFleetAsync({
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   }, []);

   const columns = [
      {
         name: "Vehicle No",
         selector: (row) => row.vehicle_no,
         sortable: true,
      },
      {
         name: "Chasis No",
         selector: (row) => row.chasis_no,
      },
      {
         name: "Engine No",
         selector: (row) => row.engine_no,
      },
      {
         name: "Vehicle Owner Name",
         selector: (row) => row.vehicle_owner_name,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => (
            <div className="d-flex align-items-center">
               <button
                  className="btn"
                  onClick={() => navigate(`/fleet-master/view/${row?.id}`)}
               >
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
               <CustomToggleSwitch
                  checked={row?.is_active === "1"}
                  onChange={() => handleActiveInactive(row)}
                  isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
               />
            </div>
         ),
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value?.toLowerCase();
      const newData = fleetMasterList?.filter((row) => {
         return (
            row.vehicle_no?.toLowerCase()?.includes(searchText) ||
            row.chasis_no?.toLowerCase()?.includes(searchText) ||
            row.vehicle_owner_name?.toLowerCase()?.includes(searchText) ||
            row.engine_no?.toLowerCase()?.includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="Fleet Master List" />
         <div className="px-3">
            <div className="d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <Stack direction={"row"} spacing={2}>
                  <DownloadReportButton
                     title="Download Maintainance Report"
                     onDownloadReport={handleDownloadMaintainanceReport}
                     confirmPopup={maintainanceReportPopup}
                  />
                  <DownloadReportButton
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={fleetReportPopup}
                  />
               </Stack>
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
